import * as React from "react";
import { Resources, useResource } from "Translations/Resources";
import { useDispatch, useSelector } from "react-redux";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { CookieNames } from "Components/Models/CookieNames";
import { Dictionary } from "lodash";
import { RootStateType } from "State/Store";
import { SettingsSubMenu } from "Components/Settings/SettingsSubMenu";
import { FilterPropsUsers, UserDto } from "Api/Api";
import { UsersTable } from "Components/Settings/Users/UsersTable";
import { getUsersAsync } from "State/Users/UserReducer";
import { booleanValueMapper } from "Utils/FilterUtils";
import { useTableFiltration } from "Hooks/Tables/useTableFiltration";

export const UsersPage: React.FunctionComponent = _ => {
  const { t } = useResource();
  const { isLoading, users } = useSelector((e: RootStateType) => e.users);

  const isActiveListItems = {
    none: t(Resources.Users.Status.None),
    true: t(Resources.Users.Status.Active),
    false: t(Resources.Users.Status.InActive),
  } as Dictionary<string>;

  const dispatch = useDispatch();
  const [filtration] = useTableFiltration<UserDto, FilterPropsUsers>({
    tableCode: CookieNames.Users,
    onDataLoad: filter => {
      dispatch(
        getUsersAsync.request({
          ...filter,
          limit: filter.rows,
          offset: filter.page * filter.rows,
        }),
      );
    },
    defaultOrderBy: "firstName",
    filters: [
      {
        propertyName: "firstAndLastName",
        defaultValue: "",
      },
      {
        propertyName: "login",
        defaultValue: "",
      },
      {
        propertyName: "isActive",
        defaultValue: "true",
        listItems: isActiveListItems,
        valueMapper: booleanValueMapper,
      },
    ],
  });

  return (
    <AuthenticatedLayout
      title={t(Resources.Settings.Title)}
      breadcrumbItems={[
        {
          name: t(Resources.Users.Breadcrumb.Title),
        },
      ]}
    >
      <SettingsSubMenu />

      <UsersTable
        users={users}
        onPageChange={filtration.onPageChange}
        isLoading={isLoading}
        filter={filtration.getFilterProps()}
        orderBy={filtration.ordering}
        paginationParams={filtration.pagination}
      />
    </AuthenticatedLayout>
  );
};
